import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  isSelected: boolean;
  onSelect: () => void;
}

const AssortLineSelectorButtons: React.FC<IProps> = ({ isSelected, onSelect }) => {
  const { t } = useTranslation();
  if (isSelected) {
    return <button className={"button medium padding-medium button-fill-main"}>{t("wybrano")}</button>;
  }

  return (
    <button className={"button medium padding-medium button-outline-main"} onClick={() => onSelect()}>
      {t("wybierz")}
    </button>
  );
};

export default AssortLineSelectorButtons;
